import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M5.591 9.792c0-.46.374-.834.834-.834h8.75c.46 0 .833.373.833.834v4.583c0 .92-.746 1.667-1.666 1.667H7.258c-.92 0-1.667-.747-1.667-1.667V9.792ZM7.258 8.75v-.131c0-1.301-.078-2.751.83-3.682.519-.531 1.357-.979 2.712-.979 1.354 0 2.193.448 2.711.979.909.93.83 2.38.83 3.682v.131" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);